import { useQuery } from '@tanstack/react-query'
import {
  listBuyStrategyCodes,
  listConsolidatedDcs,
  listDefaultStrategyGroups,
  listMilestones,
} from '@/api/cltReference'

const STALE_FOREVER = Infinity

export function useMilestones() {
  return useQuery({
    queryKey: ['milestones'],
    queryFn: listMilestones,
    staleTime: STALE_FOREVER,
  })
}

export function useBuyStrategyCodes() {
  return useQuery({
    queryKey: ['buy-strategy-codes'],
    queryFn: listBuyStrategyCodes,
    staleTime: STALE_FOREVER,
  })
}

export function useDefaultStrategyGroups() {
  return useQuery({
    queryKey: ['buy-strategy-codes', 'default-groups'],
    queryFn: listDefaultStrategyGroups,
    staleTime: STALE_FOREVER,
  })
}

export function useConsolidatedDcs() {
  return useQuery({
    queryKey: ['consolidated-dcs'],
    queryFn: listConsolidatedDcs,
    staleTime: STALE_FOREVER,
  })
}
